export function useAuth() {
    const { login, logout, refreshIdentity, isAuthenticated } =
        useSanctumAuth();
    const { user } = useUser();
    const router = useRouter();
    const config = useRuntimeConfig();
    const { auth } = useApi();

    async function register(
        first_name: string,
        last_name: string,
        name: string,
        email: string,
        password: string,
        password_confirmation: string,
        brand_data?: any,
        email_verified_at?: string,
        referral_partner?: string,
    ): Promise<any> {
        await auth.register(
            first_name,
            last_name,
            name,
            email,
            password,
            password_confirmation,
            brand_data,
            email_verified_at,
            referral_partner,
        );

        await refreshIdentity();
        await router.push(config.public.homeUrl);
    }

    async function userCompletion(
        first_name: string,
        last_name: string,
        name: string,
        email: string,
        password: string,
        password_confirmation: string,
        token?: string,
    ): Promise<any> {
        await auth.userCompletion(
            first_name,
            last_name,
            name,
            email,
            password,
            password_confirmation,
            token,
        );

        await refreshIdentity();
        await router.push(config.public.homeUrl);
    }

    async function resetPassword(
        token: string,
        password: string,
        password_confirmation: string,
    ): Promise<any> {
        await auth.resetPassword(token, password, password_confirmation);

        await refreshIdentity();
        await router.push(config.public.homeUrl);
    }

    return {
        user,
        isAuthenticated,
        login,
        register,
        userCompletion,
        logout,
        resetPassword,
        refreshIdentity,
    };
}
